import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import { useLocation, useNavigate } from 'react-router';
import { Button } from '@mui/material';
import { OrgGet } from '../../../api/orgService';
import useApi from '../../../api/useApi';
import { toast } from 'react-toastify';
import SkeletonList from '../../sections/SkeletonList';


function OrgAdminList() {

    const navigate = useNavigate()
    const location = useLocation()
    const [AllOrganisations,setAllOrganisations] =useState([])
    // const [nextPageUrl, setNextPageUrl] = useState('http://localhost:8000/api/articles/');
    const [loading, setLoading] = useState(false);

    const { request: getAllOrganisations, data:organisationData, error:organisationError,isLoading:getOrgLoading} = useApi(OrgGet);

          useEffect(() => {
            getAllOrganisations();
                 // eslint-disable-next-line
            }, []);
            
            useEffect(()=>{
              if (organisationData?.status===200) {
                setAllOrganisations(organisationData?.data);
              }
            // eslint-disable-next-line
            },[organisationData])
    
          
            // useEffect(()=>{
            //     if(location?.state?.refresh==="org"){
            //       getAllOrganisations();
            //     }
            //   // eslint-disable-next-line
            //   },[location?.state])
          
            useEffect(()=>{
                if(organisationError){
                    toast.error(`${JSON.stringify(organisationError?.response?.data,null,2)}`,{position: "top-center"});
              }
            },[organisationError]) 


    const rows = [
        { id: 1, name: 'Fountain Africa Org', description: 'the Community version', link: "/staff/organisation/detail"},
        { id: 2, name: 'Data Grid Pro', description: 'the Pro version', link: "/staff/organisation/detail?id=1" },
        { id: 3, name: 'Data Grid Premium', description: 'the Premium version', link: "/staff/organisation/detail?id=1" },
      ];
      
    const columns = [
        { field: 'id', headerName: 'Org Number', width: 200 },
        { field: 'org_name', headerName: 'Product Name', width: 200 },
        { field: 'org_description', headerName: 'Description', width: 300 },
        { field: 'org_tag', headerName: 'Organisation tag', width: 300 },
        { field: 'link', headerName: 'View Details', width: 300,
            renderCell: (params) => (
                // <Link
                //   href={params.value}
                //   style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
                // >
                //   View details →
                // </Link>
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => navigate(`/staff/organisation/detail/${params.row.id}`, {state: { orgId: params.row.id, orgName: params.row.org_name }})}
                    sx={{
                    textTransform: 'none',
                    backgroundColor: '#1976d2',
                    '&:hover': { backgroundColor: '#115293' },
                    }}
                >
                    View Details
                </Button>
              ),
         }
    
      ];
    
  if(getOrgLoading){
      return (
        <SkeletonList/>
      )
    }
  return (
    <div style={{ height: '80%', width: '100%' }}>
      <DataGrid rows={AllOrganisations?.results} columns={columns} />
    </div>
  )
}

export default OrgAdminList